import { useFormContext } from 'react-hook-form';
import { Checkbox, CheckboxProps, Typography } from 'antd';

import { InputNumberForm } from '@/components/form/InputNumber';

const { Text, Title } = Typography;

interface IElevatorShaft {
  handleBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
  isObserver: boolean;
  handlePerformCalculation: () => void;
}

export const ElevatorShaft: React.FC<IElevatorShaft> = ({
  handleBlur,
  isObserver,
  handlePerformCalculation,
}) => {
  const methods = useFormContext();

  const El_manual = methods.watch('El_manual');

  const handleCheckBox: CheckboxProps['onChange'] = (event) => {
    methods.setValue('El_manual', event?.target?.checked);
    handlePerformCalculation();
  };

  return (
    <div>
      <Title level={5}>Параметры лифтовой шахты</Title>
      <div className='grid grid-cols-2 gap-4 gap-y-8 items-end'>
        <InputNumberForm
          addonBefore={
            <i>
              F<sub>lc</sub> =
            </i>
          }
          addonAfter={
            <i>
              м<sup>2</sup>
            </i>
          }
          name='Flc'
          label='Площадь поперечного сечения кабины лифта (по внешнему контуру ограждений кабины)'
          placeholder={isObserver ? '' : 'Введите значение'}
          onBlur={handleBlur}
          size='large'
          disabled={isObserver}
        />
        <InputNumberForm
          addonBefore={
            <i>
              F<sub>ls</sub> =
            </i>
          }
          addonAfter={
            <i>
              м<sup>2</sup>
            </i>
          }
          name='Fls'
          label='Площадь поперечного сечения лифтовой шахты (по внутреннему контуру ограждений)'
          placeholder={isObserver ? '' : 'Введите значение'}
          onBlur={handleBlur}
          size='large'
          disabled={isObserver}
        />

        <InputNumberForm
          addonBefore={
            <i>
              ξ<sub>l</sub> =
            </i>
          }
          name='El'
          label='Коэффициент местного сопротивления узла "кабина-шахта" при открытых дверях кабины и шахты на основном посадочном этаже'
          placeholder={isObserver ? '' : 'Введите значение'}
          onBlur={handleBlur}
          fixValue={2}
          disabled={isObserver || !El_manual}
          size='large'
        />
        <div className='flex gap-4'>
          <Checkbox checked={El_manual} onChange={handleCheckBox} />
          <label className='text-secondary'>Ручной ввод</label>
        </div>
      </div>
    </div>
  );
};
